<script>
export default {
  name: "ViewDocuments",

  props: {
    showModal: Boolean,
    documents: {
        type: Array,
        required: true,
    },
    patient: {
        type: Object,
        required: true,
    },
  },
};
</script>
<template>
  <tail-modal :show="showModal" dimension="w-10/12">
    <template v-slot:title>
      <h5 class="font-medium text-sm">Documents</h5>
    </template>
    <template v-slot:modal-body>
      <div class="w-full flex flex-wrap items-center">
        <div class="w-full flex flex-wrap p-2 bg-gray-300 mb-2">
          <div class="flex-1">
            <h5 class="font-medium text-sm">
              Patient: {{ patient.patient || patient.names }}
            </h5>
          </div>
          <div class="flex-1">
            <h5 class="font-medium text-sm">MRN: {{ patient.patienT_ID || patient.patientID }}</h5>
          </div>
          <div class="flex-1">
            <h5 class="font-medium text-sm">No: {{ patient.morgueNo }}</h5>
          </div>
          <div class="flex-1">
            <h5 class="font-medium text-sm">Admin Date: {{ patient.date | dateFormat }}</h5>
          </div>
        </div>
        <div class=" flex flex-col items-center w-full p-1 my-2" 
            v-for="doc in documents" 
            :key="doc.id">
            <h5 class="font-medium text-sm my-1">Name: {{ doc.docName }}</h5>
            <iframe
              v-if="doc.contentType == `application/pdf`"
              :src="`data:application/pdf;base64,${doc.document}`"
              height="800"
              width="1000"
            ></iframe>
            <img
              v-else
              :src="`data:application/image;base64,${doc.document}`"
              :alt="doc.docName"
            />
        </div>
      </div>
    </template>
    <template v-slot:modal-footer>
      <button
        class="btn-danger btn-sm text-xs rounded"
        @click.prevent="$emit(`closeModal`)"
      >
        <i class="fa fa-times"></i> Close
      </button>
    </template>
  </tail-modal>
</template>
